import { createSlice } from "@reduxjs/toolkit";
import {
  uploadPdfAction,
  detectPlaceholdersAction,
  verifySignatureAction,
  getAuditLogsAction,
  cancelSessionAction,
} from "../../actions/pdfSign/pdfSignAction";

const initialState = {
  loading: false,
  error: null,
  activeSignature: null, 
  placeholders: [],
  documentPages: [], 
  documentTotalPages: 0,
  auditLogs: [],
  verificationResult: null,
};


const pdfSignSlice = createSlice({
  name: "pdfSign",
  initialState,
  reducers: {
    clearPdfSignState: (state) => {
      state.loading = false;
      state.error = null;
      state.activeSignature = null;
      state.placeholders = [];
      state.documentPages = [];
      state.documentTotalPages = 0;
      state.verificationResult = null;
    },
    clearError: (state) => {
      state.error = null;
    },
    setVerificationResult: (state, action) => {
      state.verificationResult = action.payload;
    },
    setActiveSignature: (state, action) => {
      state.activeSignature = action.payload;
      state.documentPages = action.payload?.pages || [];
      state.documentTotalPages = action.payload?.totalPages || 1;
    },
  },
  extraReducers: (builder) => {
    builder
      // Upload PDF
      .addCase(uploadPdfAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(uploadPdfAction.fulfilled, (state, action) => {
        state.loading = false;
        state.activeSignature = action.payload;
        state.documentPages = action.payload?.pages || [];
        state.documentTotalPages = action.payload?.totalPages || 0;
        state.placeholders = action.payload?.placeholders || [];
        if (action.payload?.verificationInfo) {
          state.verificationResult = action.payload.verificationInfo;
        }
      })
      .addCase(uploadPdfAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to upload PDF";
      })

      // Cancel Session
      .addCase(cancelSessionAction.fulfilled, (state) => {
        state.loading = false;
        state.activeSignature = null;
        state.placeholders = [];
        state.documentPages = [];
        state.documentTotalPages = 0;
        state.verificationResult = null;
      })

      // Detect Placeholders
      .addCase(detectPlaceholdersAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(detectPlaceholdersAction.fulfilled, (state, action) => {
        state.loading = false;
        state.placeholders = action.payload?.data || action.payload?.placeholders || action.payload || [];
        if (action.payload?.pages) {
          state.documentPages = action.payload.pages;
        }
        if (action.payload?.totalPages) {
          state.documentTotalPages = action.payload.totalPages;
        }
      })
      .addCase(detectPlaceholdersAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to parse placeholders";
      })

      // Verify Signature
      .addCase(verifySignatureAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(verifySignatureAction.fulfilled, (state, action) => {
        state.loading = false;
        const payload = action.payload;
        state.verificationResult = payload?.data || payload || null;
      })
      .addCase(verifySignatureAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to verify signature";
      })

      // Get Audit Logs
      .addCase(getAuditLogsAction.pending, (state) => {
        state.error = null;
      })
      .addCase(getAuditLogsAction.fulfilled, (state, action) => {
        state.auditLogs = action.payload;
      })
      .addCase(getAuditLogsAction.rejected, (state) => {
        state.auditLogs = [];
      });
  },
});

export const { clearPdfSignState, clearError, setVerificationResult, setActiveSignature } = pdfSignSlice.actions;
export default pdfSignSlice.reducer;
